import { SnapshotRequestMsg } from '#websocket/client/proto';
import { SnapshotRequest } from './common';
export class ListSnapshotRequest extends SnapshotRequest {
    constructor(destination) {
        super({ type: SnapshotRequestMsg.RequestType.LIST_SNAPSHOTS_REQUEST }, destination);
    }
}
